<script setup>
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  groups: { type: Array, required: true },
});

const emit = defineEmits(['open']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="sport-live-tv-filter-steps">
    <button v-for="group in groups" :key="group.key" type="button" class="sport-live-tv-filter-steps__step" @click="emit('open', group.key)">
      <span class="sport-live-tv-filter-steps__text">
        <span class="sport-live-tv-filter-steps__title">{{ group.title }}</span>
        <span class="sport-live-tv-filter-steps__count">{{ t('selectedCount', { count: group.selected.length }) }}</span>
      </span>
      <span class="sport-live-tv-filter-steps__arrow" aria-hidden="true">›</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-steps {
  display: none;
  flex-direction: column;
  gap: 4px;

  @include mobile-sm-max {
    display: flex;
  }

  &__step {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    padding: 12px;
    border: 0;
    border-radius: 8px;
    background: none;
    font-family: inherit;
    text-align: left;
    cursor: pointer;

    &:hover {
      background-color: $black50;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__title {
    color: $white;
    font-size: 13px;
    font-weight: 600;
  }

  &__count {
    color: $gray;
    font-size: 13px;
  }

  &__arrow {
    color: $white;
    font-size: 24px;
    line-height: 1;
  }
}
</style>
